import { useFetch } from "./useFetch";

export const taxKey = (v) => (v === undefined || v === null || v === "" ? "" : String(Number(v)));

export const taxOptions = (vals, current) => {
  const opts = (vals || []).map((r) => [taxKey(r.rate), `${r.name} – ${taxKey(r.rate)}%`]);
  const c = taxKey(current);
  return c && !opts.some(([v]) => v === c) ? [...opts, [c, `${c}%`]] : opts;
};

export const taxLabel = (vals, v) => (taxOptions(vals, v).find(([k]) => k === taxKey(v ?? 0)) || [, `${taxKey(v ?? 0)}%`])[1];

export const useTaxValues = () => useFetch("/admin/tax-values").data || [];
